var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 98.735 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 58.686 10.404 C 48.259 -0.099 31.354 -0.099 20.926 10.404 L 39.807 29.421 L 58.687 10.404 Z",
    fill: "hsl(0, 0%, 100%)",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 39.831 29.448 C 44.838 34.491 51.629 37.325 58.711 37.325 C 65.792 37.325 72.584 34.491 77.591 29.448 L 58.71 10.431 L 39.831 29.448 Z",
    fill: "hsl(0, 0%, 100%)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 39.784 29.444 C 29.357 39.946 12.451 39.946 2.024 29.444 L 20.904 10.426 Z",
    fill: "hsl(0, 0%, 100%)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 58.733 10.408 C 63.741 5.364 70.532 2.531 77.613 2.531 C 84.695 2.531 91.486 5.364 96.494 10.408 L 77.613 29.426 Z",
    fill: "hsl(0, 0%, 100%)",
    opacity: 0.5
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload3);
export default __webpack_public_path__ + "static/media/download (3).7cc9056528a0befd7204aaea6602ec04.svg";
export { ForwardRef as ReactComponent };